import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { SiteConfigManager, useApplicationState } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import Tournament from './Tournament';
import Tournaments from './Tournaments';

const { TOURNAMENTS } = COMPONENT_TYPES;

const TournamentsRouter = () => {
  const { authenticated, resolved } = useApplicationState();
  const tournamentPath = SiteConfigManager.getComponentPath(TOURNAMENTS);

  const isSmarticoTournamentsEnabled = SiteConfigManager.getConfig(
    'config.config.gamification.smartico.enableTournaments',
  );

  if ((resolved && !authenticated) || !isSmarticoTournamentsEnabled) {
    return <Redirect to="/" />;
  }

  return (
    <Switch>
      <Route path={`${tournamentPath}/:tournamentId`}>
        <Tournament tournamentPath={tournamentPath} />
      </Route>
      <Route path={tournamentPath}>
        <Tournaments />
      </Route>
    </Switch>
  );
};

export default TournamentsRouter;
